var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStreamChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "06FDB9D0-9752-4DEF-914A-6AEDCED0C643") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.06193333,13.6 L32.9369333,13.6 C33.524,13.6 33.9988667,13.1319333 33.9988667,12.5539333 L33.9988667,2.09213333 C33.9988667,0.937266667 33.048,1.15463195e-14 31.8738667,1.15463195e-14 L29.5664,1.15463195e-14 C29.0031333,1.15463195e-14 28.4636667,0.219866667 28.0647333,0.613133333 L17.6210667,10.8947333 C17.2232667,11.2868667 16.6826667,11.5078667 16.1194,11.5078667 L11.2132,11.5078667 C10.8278667,11.5078667 10.4493333,11.4047333 10.1195333,11.2098 L6.4056,9.01566667 C5.7324,8.61786667 4.89146667,8.61786667 4.21826667,9.01566667 L0.515666667,11.203 C0.194933333,11.3922667 7.10542736e-15,11.7322667 7.10542736e-15,12.0994667 L7.10542736e-15,12.5539333 C7.10542736e-15,13.1319333 0.474866667,13.6 1.06193333,13.6",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0401333,0.47666111 C29.2592667,-0.168205557 28.1270667,-0.158005557 27.3575333,0.502727776 L22.8944667,4.34246111 C22.5193333,4.66546111 22.0399333,4.84339444 21.5446667,4.84339444 L19.0241333,4.84339444 C18.4144,4.84339444 17.8341333,5.11086111 17.4408667,5.57666111 L11.4330667,12.6622611 C10.9332667,13.2515944 10.166,13.5213278 9.42253333,13.3671944 L5.729,12.6044611 C5.45473333,12.5477944 5.1714,12.5477944 4.896,12.6044611 L0.854533333,13.4397278 C0.358133333,13.5417278 0,13.9916611 0,14.5152611 L0,15.5681278 C0,16.2594611 0.613133333,16.7785278 1.27046667,16.6436611 L4.3044,16.0169278 C4.9402,15.8854611 5.60093333,16.0565944 6.0928,16.4804611 L10.0458667,19.8804611 C10.9491333,20.6567944 12.3000667,20.5332611 13.0480667,19.6073278 L16.6124,15.1918611 C16.8662667,14.8790611 17.2017333,14.6433278 17.5825333,14.5118611 L22.6360667,12.7733278 C23.1143333,12.6089944 23.5189333,12.2825944 23.7807333,11.8507944 L27.5819333,5.57326111 C28.1962,4.55892778 29.4836667,4.23932778 30.4776,4.85472778 L32.3906667,6.03906111 C33.099,6.47766111 34,5.95179444 34,5.09952778 L34,4.43652778 C34,3.99906111 33.8050667,3.58539444 33.4673333,3.30659444 L30.0401333,0.47666111 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.0-WebPageBuilder-EmptyWidgets",
    transform: "translate(-203.000000, -600.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WPB-Widgets",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components",
    transform: "translate(160.000000, 464.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Stream-Chart/40dp",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(3.000680, 19.329688)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey",
    mask: "url(#mask-2)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.000680, -19.329688)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(3.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Dark",
    mask: "url(#mask-4)",
    fill: "#727272"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.000000, -8.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamChart);
export default __webpack_public_path__ + "static/media/streamChart.266e745dedea70658d9f644d433b4e9d.svg";
export { ForwardRef as ReactComponent };